// ============================================================================
// crmRotaAtiva · o CRM aberto avisa os providers globais (27/10/2026)
// ============================================================================
// CRM_SEM_RECARGA: enquanto a tela do CRM (CrmTrabalho) está montada, o sync do
// Avec (doSync e doDailySync de 60 s) e o refresh de 60 s do DataContext param:
// o CRM não usa esses dados e, no iPhone, a rodada travava a digitação. Ao sair
// do CRM, um sync imediato. Módulo puro (testado no node), sem React.
// ============================================================================

let ativos = 0;
const ouvintes = new Set();

function avisar() {
  const ativa = ativos > 0;
  for (const fn of [...ouvintes]) { try { fn(ativa); } catch { /* ok */ } }
}

/** Marca o CRM como aberto. Devolve a função que desmarca (idempotente). */
export function marcarRotaCrm() {
  ativos += 1;
  if (ativos === 1) avisar();
  let feito = false;
  return () => {
    if (feito) return;
    feito = true;
    ativos = Math.max(0, ativos - 1);
    if (ativos === 0) avisar();
  };
}

export function rotaCrmAtiva() { return ativos > 0; }

export function ouvirRotaCrm(fn) {
  ouvintes.add(fn);
  return () => { ouvintes.delete(fn); };
}

/** O polling global (Avec, DataContext) pula a rodada? Só com o interruptor ligado e o CRM aberto. */
export function pollingGlobalPausado({ ligado = false, rotaCrm = rotaCrmAtiva() } = {}) {
  return !!ligado && !!rotaCrm;
}

// Só para testes.
export function _resetRotaCrm() { ativos = 0; ouvintes.clear(); }
